import {Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import { ReportPageInterface } from 'src/app/interface';
import { FieldValue, Report, FieldValueReset } from 'src/app/model';
import { FooterButtonOption, PageNumbers, RecurringAmount, YesNo } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import { radioGroupOption } from '../../commonModel/common-classes';
import {routeTransition} from '../../../../animations/route-transition';

@Component({
  selector: 'app-recurring-revenue',
  templateUrl: './recurring-revenue.component.html',
  styleUrls: ['./recurring-revenue.component.scss'],
  animations: [routeTransition],
})
export class RecurringRevenueComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  @ViewChild('recurringRevForm') recurringRevForm: NgForm;

  recurringList: radioGroupOption[] = [];
  percentageList: radioGroupOption[] = [];

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  constructor(private reportService: ReportService,
    private reportProvider: ReportProvider,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    this.recurringList.push({ title: 'Yes', value: YesNo.YES });
    this.recurringList.push({ title: 'No', value: YesNo.NO });

    this.percentageList.push({ title: '0 – 25%', value: RecurringAmount._0_TO_25_PERCENT });
    this.percentageList.push({ title: '26 – 50%', value: RecurringAmount._26_TO_50_PERCENT });
    this.percentageList.push({ title: '51 – 75%', value: RecurringAmount._51_TO_75_PERCENT });
    this.percentageList.push({ title: '76 – 100%', value: RecurringAmount._76_TO_100_PERCENT });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   */
  callUpdateAPI(fieldName: string) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST.RISK[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description check page is valid or not
   * @returns for validation: return true false
   */
  checkValidation() {
    if (this.currentReport && this.currentReport.LATEST && this.currentReport.LATEST.RISK && this.currentReport.LATEST.RISK.RR_IS_RECURRING) {
      if (this.currentReport.LATEST.RISK.RR_IS_RECURRING == YesNo.YES) {
        return this.currentReport.LATEST.RISK.RR_RECURRING_AMOUNT ? true : false;
      } else {
        return true;
      }
    }
    return false;
  }

  /**
   * @description field reset API
   */
  resetFieldAPI() {
    this.currentReport.LATEST.RISK.RR_IS_RECURRING = null;
    this.currentReport.LATEST.RISK.RR_RECURRING_AMOUNT = null;
    let objFieldValueReset = new FieldValueReset();
    objFieldValueReset.GROUP = 'RISK';
    objFieldValueReset.FIELD_LIST = ['RR_IS_RECURRING', 'RR_RECURRING_AMOUNT'];
    this.reportProvider.resetReportField(this.currentReport.LATEST.ID, objFieldValueReset).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });

  }

  showHideRecurringRev() {
    this.currentReport.LATEST.RISK.OPT_RR = !this.currentReport.LATEST.RISK.OPT_RR;
    let fieldName = 'OPT_RR';
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST.RISK[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.recurringRevForm.valid || this.currentReport?.isLocked;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.RECURRING_REVENUE);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/conclusion`);
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/risk/barriers-entry`);
    } else if (buttonOption == FooterButtonOption.SKIP_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.RECURRING_REVENUE, true);
      this.resetFieldAPI();
    }  else if (buttonOption == FooterButtonOption.EXTRA_CLICK) {
      this.showHideRecurringRev();
    }
  }

}
